import React, { useEffect, useContext, useState } from "react";
import DropDown from "../../components/_default/DropDown";
import MealplanPopupData from "../../components/_clients/LargePopup/mealplanPopupData";
import WorkoutPopupData from "../../components/_clients/LargePopup/WorkoutPopup/workoutPopupData";
import PhasePopupData from "../../components/_clients/LargePopup/PhasePopupData/";
import ClientsList from "../../components/_clients/ClientsList";
import ClientProfile from "../../components/_clients/ClientProfile";
import UserContext from "../../services/context/userContext";
import { getClients, getDailyMeasurementProgress, getCLientById, getAllCoaches, getAllClients } from "../../services/firebase/firestore/getData";
import Workout from "../../components/_clients/Workout";
import Chat from "../../components/_clients/Chat";
import Overview from "../../components/_clients/Overview";
import Calendar from "../../components/_clients/Calendar";
import CalendarItem from "../../components/_default/Calendar";
import Mealplan from "../../components/_clients/Form";
import Programsplan from "../../components/_clients/Programs";
import TodoList from "../../components/_clients/Calendar/TodoList";
import AddButton from "../../components/_default/AddButton";
import { useCookies } from "react-cookie";
import "./Subs.scss";
import Phase from "../../components/_phase";
import Loading from "../../components/_default/Loading";
import logo from '../../assets/images/logo.svg';
import Sub from "./sub";
import Subclients from "./subclients";

function Subs({ ...props }) {
  const [cookies, setCookie] = useCookies(["clients_active_page"]);
  const [allCoaches, setAllCoaches] = useState([]);
  const [allClients, setAllClients] = useState([]);
  const [alphabetical, setAlphabetical] = useState(false);
  const [noCoach, setNoCoach] = useState(false);
  const [adminOnly, setAdminOnly] = useState(false);
  const [alphabeticalCoach, setAlphabeticalCoach] = useState(false);

  const [filtered, setFiltered] = useState([]);
  const [filteredCoach, setFilteredCoach] = useState([]);

  var a = new Date();
  var year = a.getFullYear();
  var month = a.getMonth()+1;
  var day = a.getDate();
  
  if(month < 10) {
    month = "0" + month;    
  }
  if(day < 10) {
    day = "0" + day;
  }
  var time = year + "-" + month + "-" + day;
  var currentTime = year + "-" + month + "-" + day;
  var date = day + "/" + month + "/" + year;
  let longMonth = a.toLocaleString('en-us', { month: 'long' }); 
  const [fullTime, setFullTime] = useState(day + " " + longMonth + " " + year);
  let shortMonth = a.toLocaleString('en-us', { month: 'short' });
  const [shortFullTime, setShortFullTime] = useState(day + " " + shortMonth + " " + year);
  const [Time, setTime] = useState(time);
  const user = useContext(UserContext);

  const DropDownOptions = [
    'Trial',
    'Closed',
    'Paid'
  ]

  useEffect(() => {
    getAllCoaches(callback => {
          console.log("all coached",callback)
          setAllCoaches(callback);
        })
        
        getAllClients(callback => {
      console.log("all clients",callback)
        setAllClients(callback);
    })
  }, [])

  useEffect(() => {
    setFiltered([]);
    let _filtered = [];
    if (noCoach === true) {
      allClients.forEach(client => {
        if (!client.coach) {
          _filtered.push(client);
        }
      })
    }
    if (alphabetical === true) {
      _filtered.sort((a, b) => a.first_name.localeCompare(b.first_name))
      allClients.sort((a, b) => a.first_name.localeCompare(b.first_name))
    }else{
      allClients.sort((a, b) =>  0.5 - Math.random())
    }
    setFiltered(_filtered);
  }, [noCoach, alphabetical]);

  useEffect(() => {
    setFiltered([]);
    let _filtered = [];
    if (adminOnly === true) {
      allCoaches.forEach(client => {
        if (!client.admin) {
          _filtered.push(client);
        }
      })
    }
    if (alphabeticalCoach === true) {
      _filtered.sort((a, b) => a.first_name.localeCompare(b.first_name))
      allCoaches.sort((a, b) => a.first_name.localeCompare(b.first_name))
    }else{
      allCoaches.sort((a, b) =>  0.5 - Math.random())
    }
    setFilteredCoach(_filtered);
  }, [adminOnly, alphabeticalCoach]);

  return (
    <div className="c-page-wrapper c-page-dashboard c-page-exercises">
      <div className="c-header">
        <div className="c-header-container">
          <div className="c-header-nav" style={{ justifyContent: 'center' }}>
            
            <h1 className="c-header-title">Access control</h1>
            
          </div>
          <div className="c-header-add">
          </div>
          <div className="c-header-logo">
            <img src={logo} alt="Logo" />
          </div>
        </div>
      </div>
      <br /><br /><br />
      <div className="c-page-wrapper--exercises">
      <div className="filters">
        <h2 style={{ fontWeight: 'bold' }}>Coaches</h2>
        <div className="filters">
            <div className="filters">
              <p>No admin</p>
              <label class="switch" style={{ position: 'relative' }}>
                <input type="checkbox" name="automatich" checked={adminOnly ? true : false} onClick={() => setAdminOnly(!adminOnly)} />
                <span class="slider round"></span>
              </label>
            </div>
            <p>Alphabetic</p>
              <label class="switch" style={{ position: 'relative' }}>
                <input type="checkbox" name="automatich" checked={alphabeticalCoach ? true : false} onClick={() => setAlphabeticalCoach(!alphabeticalCoach)} />
                <span class="slider round"></span>
              </label>
            </div>
          </div>
        <div className="c-page-main--exercises">
          <div className="c-exercise-list">
            {
              filteredCoach.length > 0 ?(
                filteredCoach && filteredCoach.map((coach, idx) => (
                  <Sub key={idx} coach={coach} />
              ))
              ):(
                allCoaches && allCoaches.map((coach, idx) => (
                  <Sub key={idx} coach={coach} />
                ))
              ) 
            }
          </div>
        </div>
      </div>
      <br /><br /><br />

      <div className="c-page-wrapper--exercises">
        <div className="filters">
          <h2 style={{ fontWeight: 'bold' }}>Clients</h2>
          <div className="filters">
            <div className="filters">
              <p>No coach</p>
              <label class="switch" style={{ position: 'relative' }}>
                <input type="checkbox" name="automatich" checked={noCoach ? true : false} onClick={() => setNoCoach(!noCoach)} />
                <span class="slider round"></span>
              </label>
            </div>
            <p>Alphabetic</p>
              <label class="switch" style={{ position: 'relative' }}>
                <input type="checkbox" name="automatich" checked={alphabetical ? true : false} onClick={() => setAlphabetical(!alphabetical)} />
                <span class="slider round"></span>
              </label>
            </div>
          </div>
          <div className="c-page-main--exercises">
        </div>
          <div className="c-exercise-list">
            {
            filtered.length > 0 ? (
              filtered && filtered.map((client, idx) => (
                  <Subclients key={idx} client={client} />
              ))
            ):(
              allClients && allClients.map((client, idx) => (
                <Subclients key={idx} client={client} />
              ))
            )
            }
          </div>
      </div>
      <br /><br /><br />
    </div>
  )
}

export default Subs;